import { render, staticRenderFns } from "./express-applyreturn.vue?vue&type=template&id=828ff744&scoped=true"
import script from "./express-applyreturn.vue?vue&type=script&lang=ts"
export * from "./express-applyreturn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828ff744",
  null
  
)

export default component.exports